<template>
    <validation-observer v-slot="{ handleSubmit }">
        <form class="form tw-container" @submit.prevent="handleSubmit(formSubmit)" novalidate ref="submitForm">
            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
                <h3 v-html=" $t ('page.form.title')" class="tw-py-3"></h3>
                <p v-html=" $t ('page.form.subtitle')" class="tw-py-3"></p>
            </div>
            <fieldset>
                <div class="tw-px-3 tw-grid tw-grid-cols-1 tw-gap-2 md:tw-grid-cols-3 md:tw-px-12 ">
                    <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                placeholder=" "
                                v-model.lazy="fullName"
                            >
                            <label>
                                {{ $t ('page.form.fullName')}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="text"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                {{ $t ('page.form.email')}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-companyName" :class="classes">
                            <input type="text"
                                placeholder=" "
                                v-model.lazy="companyName"
                            >
                            <label>
                                {{ $t ('page.form.companyName')}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" rules="url" v-slot="{ classes }">
                        <div class="input-group input-group-companyUrl" :class="classes">
                            <input type="text"
                                placeholder=" "
                                v-model="companyUrl"
                                rules="url"
                            >
                            <label>
                                {{ $t ('page.form.companyUrl')}}
                            </label>
                        </div>
                    </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-phone" :class="classes">
                            <input type="tel"
                                placeholder=" "
                                v-model="phone"
                                oninput="this.value = this.value.replace(/[^0-9.+]/g, '').replace(/(\..*)\./g, '$1');"
                                maxlength="20"
                            >
                        <label>
                            {{ $t ('page.form.phone')}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="" v-slot="{ classes }">
                    <div class="select-group select-group-contacted" :class="classes">
                        <select
                            v-model="contacted"
                            class="tw-block tw-w-full tw-py-3 tw-px-4"
                            placeholder=" "
                            maxlength="15"
                            tabindex="0"
                        >
                            <option value="start_campaign"> {{ $t ('page.form.select.startCampaign')}}</option>
                            <option value="get_demo"> {{ $t ('page.form.select.getDemo')}}</option>
                            <option value="be_contacted"> {{ $t ('page.form.select.contacted')}}</option>
                        </select>
                    </div>
                </validation-provider>
                </div>
                <div class="tw-px-3 lg:tw-px-12">
                    <validation-provider class="tw-w-full tw-w-block" v-slot="{ classes }">
                        <div class="input-group input-group-textarea" :class="classes">
                        <textarea
                            class="tw-message tw-resize-none tw-w-full"
                            :placeholder="$t ('page.form.placeholder')"
                            maxlength="400"
                            v-model="message"
                        />
                        </div>
                    </validation-provider>
                </div>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="tw-px-3 md:tw-px-12">
                        <div class="form-check">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                    <i18n path="page.form.privacyPolicy.text" tag="span" for="page.form.privacyPolicy.link" class="tw-text-black">
                                        <a :href="$t('page.form.privacyPolicy.url')" target="_blank"><u>{{ $t('page.form.privacyPolicy.link') }}</u></a>
                                    </i18n>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-flex tw-text-center tw-mb-4 tw-mt-8">
                    <button type="submit" class="btn-form-page">
                       {{$t ('page.form.submit')}}
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/url';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            email: '',
            companyName: '',
            companyUrl: '',
            phone: '',
            contacted: 'start_campaign',
            message: '',

            formLoading: false,
            errors: [],
            usedClasses: ['.has-error'],
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                pageLang: this.$i18n.locale,
                fullName: this.fullName,
                email: this.email,
                companyName: this.companyName,
                companyUrl: this.companyUrl,
                phone: this.phone,
                contacted: this.contacted,
                message: this.message,
            };

            const config = {
                headers: {
                    Authorization : 'Bearer ' + this.$store.state.token,
                    Language : this.$i18n.locale,
                }
            }

            axios.post(action, data, config)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
